export default __webpack_public_path__ + "static/media/Resume.fabd7508.pdf";